module.exports = __webpack_public_path__ + "static/media/o4.716bc616.jpg";